import { combineReducers } from 'redux';
import details from '../../details/reducers';
import twoFactorAuth from '../../2fa/reducers';

export default combineReducers({
  details,
  twoFactorAuth
});
